import React, { useState, useEffect } from 'react';
import '../scss/form.scss';
import { ReactComponent as CheckIcon } from '../images/check-icon-green.svg'
import { ReactComponent as CrossIcon } from '../images/cross-red.svg'
import { useGenerateOtpMutation } from '../lib/services/authApi';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { openErrorModal, setError, setOtp, setPopError, setSuccess } from '../lib/features/OtpSlice';

const OtpInputs = ({ length = 4, onOtpUpdate, error, handleIsKeyboardOpen }) => {
    const [timer, setTimer] = useState(30);
    const [otpSent, setOtpSent] = useState(true);
    const [filled, setFilled] = useState(false);
    const [generateOtp] = useGenerateOtpMutation()
    const location = useLocation()
    const queryParams = new URLSearchParams(location.search)
    const phone = queryParams.get('phone') ? queryParams.get('phone') : localStorage.getItem('phone')
    const pagesuccess = useSelector((state) => state.otp.success);
    const otp = useSelector((state) => state.otp.otp);
    const dispatch = useDispatch()
    const handleGenerateOtp = async () => {
        try {
            const result = await generateOtp({ phone: phone.split(' ').join('') })
            setFilled(false)
            if (result.data && result.data.status === 'error') {
                dispatch(setPopError(result.data.message))
                dispatch(openErrorModal())
            }
            if (result.data && result.data.http_code === '201') {
                dispatch(setPopError(result.data.message))
                dispatch(openErrorModal())
            } else if (result.error) {
                dispatch(setPopError('Please check your internet or try again later.'))
                dispatch(openErrorModal())
            } else {
                dispatch(setSuccess('OTP sent successfully'))
                setTimer(30);
                setOtpSent(true)
                const countdown = setInterval(() => {
                    setTimer((prev) => {
                        if (prev <= 1) {
                            clearInterval(countdown);
                            setOtpSent(false)
                            return 0;
                        }
                        return prev - 1;
                    });
                }, 1000);
                setTimeout(() => {
                    dispatch(setSuccess(''))
                }, 2000);
            }
        } catch (error) {
            dispatch(setError('Something went wrong. Please try again later.'));
        }
    }

    useEffect(() => {
        const countdown = setInterval(() => {
            setTimer((prev) => {
                if (prev <= 1) {
                    clearInterval(countdown);
                    setOtpSent(false)
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(countdown);
    }, []);

    const handleChange = (e) => {
        const value = e.target.value ? e.target.value.replace(/[^0-9]/g, "") : ''
        if (/^\d*$/.test(value) && value.length <= length) {
            dispatch(setOtp(value));
            onOtpUpdate(value)
            if (value.length === length) {
                setFilled(true)
            } else {
                setFilled(false)
            }
        }
    };

    const handleResend = () => {
        dispatch(setOtp(''));
        dispatch(setError(''))
        handleGenerateOtp()
    };

    return (
        <div className="otp-container">
            <div className='otp'>
                <input
                    type="text"
                    value={otp}
                    inputMode="numeric"
                    onChange={handleChange}
                    maxLength={length}
                    placeholder=' '
                    className="otp-input form-control"
                    onBlur={() => {
                        setTimeout(() => {
                            handleIsKeyboardOpen(false);
                        }, 1000);
                    }}
                    onFocus={() => handleIsKeyboardOpen(true)}
                />
                <label>Enter OTP</label>
                {error && <div className="error">{error}</div>}
                {pagesuccess && <div className="success">{pagesuccess}</div>}
                {filled && !error && <span className='completed'><CheckIcon /></span>}
                {error && otp && <span className='completed'><CrossIcon style={{ cursor: 'pointer' }} onClick={() => {
                    dispatch(setOtp(''))
                    setFilled(false)
                }} /></span>}
            </div>
            <div className="timer">
                <div>{timer ? <span className='time'>Resend OTP in {timer}s</span> : <span onClick={handleResend} className={`link ${otpSent ? 'disabled' : null}`}>Resend OTP</span>}</div>
            </div>
        </div>
    );
};

export default OtpInputs;
